import { useState } from "react";
import api, { formatApiError, fmtDate } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export const CarryoverDialog = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [rows, setRows] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear() + (new Date().getMonth() >= 9 ? 1 : 0));
  const [busy, setBusy] = useState(false);

  const start = async () => {
    setOpen(true);
    const { data: d } = await api.get("/leave-carryover/preview");
    setData(d); setRows(d.rows);
  };
  const apply = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/leave-carryover/apply", { new_year: Number(year), items: rows.map((x) => ({ employee_id: x.employee_id, days: Number(x.carry) || 0 })) });
      toast.success(`Leave carried into ${year} for ${r.applied} staff`); setOpen(false);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy(false);
  };
  const setCarry = (id, v) => setRows((rs) => rs.map((x) => (x.employee_id === id ? { ...x, carry: v } : x)));

  return (
    <>
      <Button data-testid="carryover-open-btn" variant="outline" onClick={start}>Carry leave into next year</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto kqm-scroll">
          <DialogHeader><DialogTitle>Carry leave into next year</DialogTitle></DialogHeader>
          {!data ? <div className="text-sm text-zinc-500">Loading…</div> : <>
            <p className="text-sm text-zinc-600">Unused annual leave is carried over up to <b data-testid="carryover-max">{data.max_days} days</b> (set in Settings). Taken days and adjustments reset and each person gets their full entitlement for the new year.</p>
            {data.last_run && <p className="text-xs text-amber-700" data-testid="carryover-last">Last run: into {data.last_run.new_year} on {fmtDate(data.last_run.created_at)}</p>}
            <div className="flex items-center gap-2 text-sm"><span>Carry into year</span><Input data-testid="carryover-year" type="number" value={year} onChange={(e) => setYear(e.target.value)} className="w-28" /></div>
            <div className="border border-zinc-200 rounded-md overflow-x-auto">
              <table className="w-full text-sm">
                <thead><tr className="text-left text-xs uppercase text-zinc-500 border-b"><th className="p-2">Employee</th><th className="p-2 text-right">Unused</th><th className="p-2 text-right">Carry</th></tr></thead>
                <tbody>{rows.map((r) => (
                  <tr key={r.employee_id} className="border-b border-zinc-50" data-testid={`carryover-row-${r.employee_id}`}>
                    <td className="p-2">{r.name}</td><td className="p-2 text-right num">{r.remaining}</td>
                    <td className="p-2 text-right"><Input data-testid={`carryover-days-${r.employee_id}`} type="number" step="0.5" min="0" max={data.max_days} value={r.carry} onChange={(e) => setCarry(r.employee_id, e.target.value)} className="w-24 ml-auto h-8" /></td>
                  </tr>))}</tbody>
              </table>
            </div>
            <Button data-testid="carryover-confirm-btn" disabled={busy} onClick={apply} className="w-full bg-slate-900 text-white">Confirm carry-over into {year}</Button>
          </>}
        </DialogContent>
      </Dialog>
    </>
  );
};
